import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getArticles, getCategories } from "@/lib/api";
import BrandBand from "@/components/BrandBand";

export default function Learn() {
  const { category } = useParams();
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategories().then(setCategories).catch(() => {});
    getArticles(category ? { category } : {}).then(setArticles).catch(() => {});
  }, [category]);

  const currentCat = categories.find((c) => c.slug === category);

  return (
    <div data-testid="learn-page">
      <section className="section pb-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-8">
              <div className="overline">{currentCat ? currentCat.kicker : "The library"}</div>
              <h1 className="font-serif-editorial tight-track mt-6" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", lineHeight: 1 }}>
                {currentCat ? currentCat.name : "Learn."}
              </h1>
              <p className="mt-8 text-lg" style={{ maxWidth: "36rem" }}>
                {currentCat ? currentCat.description : "A growing editorial collection on Small Intestinal Bacterial Overgrowth — evidence-based, calmly written, and carefully reviewed."}
              </p>
            </div>
          </div>
        </div>
      </section>

      {!category && (
        <section className="pb-16" data-testid="categories-nav">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10">
            <div className="rule mb-10" />
            <div className="flex flex-wrap gap-x-8 gap-y-4">
              <Link to="/learn" className="overline editorial-link" data-testid="filter-all">All</Link>
              {categories.map((c) => (
                <Link
                  to={`/learn/${c.slug}`}
                  key={c.slug}
                  className="overline editorial-link"
                  data-testid={`filter-${c.slug}`}
                  style={{ opacity: 0.75 }}
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-20">
            {articles.map((a) => (
              <Link to={`/article/${a.slug}`} key={a.slug} className="group" data-testid={`learn-article-${a.slug}`}>
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={a.image} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="mt-6">
                  <div className="overline">{a.kicker} · {a.reading_time}</div>
                  <div className="font-serif-editorial mt-3" style={{ fontSize: "1.7rem", lineHeight: 1.15 }}>{a.title}</div>
                  <div className="mt-3 text-sm opacity-80">{a.excerpt}</div>
                </div>
              </Link>
            ))}
            {articles.length === 0 && (
              <div className="col-span-full text-lg font-serif-editorial opacity-60">More editorial coming soon.</div>
            )}
          </div>
        </div>
      </section>

      <BrandBand />
    </div>
  );
}
